import axios from "axios";
import { ApiError } from "../../Models/ApiError";
import { HandleError } from "../../Helpers/ErrorHandler";
import { DeviceActivateRequest } from "../../Models/DeviceActivateRequest";
import { DeviceDeactivateRequest } from "../../Models/DeviceDeactivateRequest";
import { DeviceDeactivateResponse } from "../../Models/DeviceDeactivateResponse";
import { DeviceActivationCheckResponse } from "../../Models/DeviceActivationCheckResponse";
import { DeviceActivateResponse } from "../../Models/DeviceActivateResponse";

const API_URL = process.env.REACT_APP_API_URL;

export const checkDeviceActivationAPI = async (deviceId: string): Promise<DeviceActivationCheckResponse> => {
  return new Promise<DeviceActivationCheckResponse>((resolve, reject) => {
    axios
      .get<DeviceActivationCheckResponse>(`${API_URL}activation/check/${encodeURI(deviceId)}`)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};

export const activateDeviceAPI = async (model: DeviceActivateRequest): Promise<DeviceActivateResponse> => {
  return new Promise<DeviceActivateResponse>((resolve, reject) => {
    axios
      .post<DeviceActivateResponse>(`${API_URL}activation/activate`, model)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};

export const deactivateDeviceAPI = async (model: DeviceDeactivateRequest): Promise<DeviceDeactivateResponse> => {
  return new Promise<DeviceDeactivateResponse>((resolve, reject) => {
    axios
      .post<DeviceDeactivateResponse>(`${API_URL}activation/deactivate`, model)
      .then((resp) => {
        return resolve(resp.data);
      })
      .catch((error: any) => {
        const apiErr: ApiError = HandleError(error);
        return reject(apiErr);
      });
  });
};
